import { applyMiddleware, createStore } from "redux";
import reducers from "./reducers";
import { isDevelopment } from "js/config";
import apiMiddleware from "./middleware/apiMiddleware";
import loggingMiddleware from "./middleware/loggingMiddleware";

export default (initialState = {}) => {
    let middleware = isDevelopment
        ? applyMiddleware(apiMiddleware(), loggingMiddleware)
        : applyMiddleware(apiMiddleware());
    return createStore(reducers(), initialState, middleware);
};
